module.exports = __webpack_public_path__ + "media/גלגל.a9c752cb.mp3";